import { setRemoteDefinitions } from '@nrwl/angular/mf';

// The correct module-federation manifest to load depends on `config.json`'s
// `name` field, which is only known at runtime (this file is swapped per
// environment during deployment) — so the manifest URL can't be picked
// before config.json resolves. Waiting for that response before even
// starting the manifest fetch turns this into a 2-round-trip waterfall.
// Instead, kick off requests for every known manifest variant *at the same
// time* as config.json — they're all tiny static JSON files (~130-220 bytes),
// so fetching all 4 costs nothing extra, and by the time config.json
// resolves the matching manifest response is usually already in flight or
// done, cutting the critical path down to ~1 round trip.
const knownManifestPaths: Record<string, string> = {
  local: '/assets/module-federation.manifest.json',
  acc: '/assets/module-federation.manifest.acc.json',
  pre: '/assets/module-federation.manifest.pre.json',
  prod: '/assets/module-federation.manifest.prod.json',
};

const configPromise = fetch('/assets/config/config.json', { credentials: 'same-origin' }).then(res => res.json());
const knownManifestPromises: Record<string, Promise<any>> = Object.fromEntries(
  Object.entries(knownManifestPaths).map(([env, path]) => {
    const promise = fetch(path).then(res => res.json());
    // Attach a silent handler so a rejected prefetch (e.g. missing/404
    // manifest, invalid JSON) for one of the ~3 non-selected environments
    // never surfaces as an unhandled promise rejection / console noise.
    // The `manifestPromise` chain below still gets its own independent
    // rejection notification via `.then()`/`.catch()` for whichever
    // manifest is actually selected.
    promise.catch(() => undefined);
    return [path, promise];
  })
);

configPromise
  .then(config => {
    const runtimeEnv = config.name;
    const manifestPath = getProfile(runtimeEnv);
    // Reuse the already in-flight/completed prefetch for known environments;
    // only fall back to a fresh fetch for an unrecognized `name` value.
    const manifestPromise = knownManifestPromises[manifestPath]
      ?? fetch(manifestPath).then(res => res.json());
    return manifestPromise.then(definitions => setRemoteDefinitions(definitions));
  })
  .catch(err => console.error(err));

console.time('bootstrap-import');
const bootstrapPromise = import('./bootstrap');
bootstrapPromise.then(() => {
  console.timeEnd('bootstrap-import');
  console.log('Bootstrap loaded');
})
  .catch(err => console.error(err));
setTimeout(() => {
  console.log('Still waiting for bootstrap after 5 seconds');
}, 5000);


function getProfile(name:string):string{
  if(name !=='local'){
    return `/assets/module-federation.manifest.${name}.json`;
  }
  return '/assets/module-federation.manifest.json';
}




